<template>
    <section class="section content-area bg-grey ptb_100">
        <div class="container">
            <div class="row justify-content-between">
                <div class="col-12 col-lg-6">
                    <!-- Content Inner -->
                    <div class="content-inner text-center">
                        <!-- นิลิคอน ประเทศไทย รับทำแอปพลิเคชันทุกแพลตฟอร์ม ตอบรับทุกความต้องการจากลูกค้า ทั้งภาครัฐและเอกชน มากกว่า 50 บริษัทชั้นนำ ใช้บริการของทางเรา ด้วยยอดดาว์นโหลดที่มากกว่า 10 ล้าน และ ยอดวิวรวมที่มากกว่า 100 ล้านวิว…
ติดต่อสอบถามได้ที่ : 02-494-3851  ( เวลาทำการ 09:00น. – 19:00น. ) นอกช่วงเวลาทำการ, วันเสาร์-อาทิตย์
โทร. 090-985-3484   หรือ ส่ง Requirement ความต้องการมาได้ที่ Email. info@nilecon.com -->
                        <!-- Section Heading -->
                        <div class="section-heading text-center mb-3">
                            <h2>{{$t('home.body1')}}</h2>
                            <p class="d-none d-sm-block mt-4">{{$t('home.body2')}}</p>
                            <!-- <p class="d-block d-sm-none mt-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati.</p> -->
                        </div>
                        <!-- Content List -->
                        <ul class="content-list text-left">
                            <!-- Single Content List -->
                            <li class="single-content-list media py-2">
                                <div class="content-icon pr-4">
                                    <span class="color-1"><i class="fas fa-angle-double-right"></i></span>
                                </div>
                                <div class="content-text media-body">
                                    <span><b>{{$t('home.body3')}}</b><br>{{$t('home.body4')}}</span>
                                </div>
                            </li>
                            <!-- Single Content List -->
                            <li class="single-content-list media py-2">
                                <div class="content-icon pr-4">
                                    <span class="color-1"><i class="fas fa-angle-double-right"></i></span>
                                </div>
                                <div class="content-text media-body">
                                    <span><b>{{$t('home.body5')}}</b><br>{{$t('home.body6')}}<div class="" href="mailto:spdevsolution@gmail.com">spdevsolution@gmail.com</div></span>
                                </div>
                            </li> 
                        </ul>
                       
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <!-- Service Thumb -->
                    <div class="service-thumb mx-auto pt-4 pt-lg-0">
                        <img src="assets/img/home-1.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>